import {
  useEffect, useCallback, useState, useRef, useMemo,
} from 'react';
import { debounce } from 'lodash';
import { useDispatch } from 'react-redux';
import { ScrollStates } from '../constants';
import { setScrollState } from '../store/slices/scroll';

// Hook
const useOnScrollStop = () => {
  const dispatch = useDispatch();
  const [scrollStatus, setScrollStatus] = useState(null);
  const refState = useRef(null);

  const handleScroll = () => {
    setScrollStatus(ScrollStates.SCROLLING);
  };

  const handleScrollDone = () => {
    setScrollStatus(ScrollStates.DONE);
  };

  // TODO: this is stupid, refactor
  const debouncedHandleScroll = useMemo(() => debounce(handleScroll, 250, { leading: true }), []);
  const debouncedHandleScrollDone5000 = useMemo(() => debounce(handleScrollDone, 5000), []);
  const debouncedHandleScrollDone300 = useMemo(() => debounce(handleScrollDone, 300), []);

  const onRefSet = useCallback((ref) => {
    refState.current = ref;
    if (ref === 'body') {
      const body = window;

      body.addEventListener('scroll', debouncedHandleScroll);
      body.addEventListener('scroll', debouncedHandleScrollDone5000);
    }
    if (ref && ref !== 'body') {
      ref.addEventListener('scroll', debouncedHandleScroll);
      ref.addEventListener('scroll', debouncedHandleScrollDone300);
    }
  }, [debouncedHandleScroll, debouncedHandleScrollDone5000, debouncedHandleScrollDone300]);

  useEffect(() => {
    if (scrollStatus) {
      dispatch(setScrollState({ status: scrollStatus }));
    }
  }, [scrollStatus, dispatch]);

  useEffect(() => () => {
    const target = refState.current === 'body' ? window : refState.current;
    if (target) {
      debouncedHandleScroll.cancel();
      debouncedHandleScrollDone5000.cancel();
      debouncedHandleScrollDone300.cancel();
      target.removeEventListener('scroll', debouncedHandleScroll);
      target.removeEventListener('scroll', debouncedHandleScrollDone5000);
      target.removeEventListener('scroll', debouncedHandleScrollDone300);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    onRefSet,
  };
};

export default useOnScrollStop;
